module.exports = __webpack_public_path__ + "img/e7ace94.jpg";